interface IJavascriptProps {
  color?: string;
}

const Javascript: React.FC<IJavascriptProps> = (props) => {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
    >
      <path
        fill={props.color || "#000"}
        d="M39.188.125H4.812A4.689 4.689 0 0 0 .125 4.813v34.374c0 2.588 2.1 4.688 4.688 4.688h34.374c2.588 0 4.688-2.1 4.688-4.688V4.813c0-2.588-2.1-4.688-4.688-4.688ZM23.934 34.246c0 4.258-2.5 6.201-6.143 6.201-3.291 0-5.195-1.699-6.172-3.76l3.35-2.021c.644 1.143 1.23 2.11 2.646 2.11 1.348 0 2.207-.528 2.207-2.589V20.213h4.112v14.033Zm9.726 6.201c-3.818 0-6.289-1.816-7.49-4.199l3.35-1.933c.878 1.435 2.03 2.5 4.052 2.5 1.7 0 2.793-.85 2.793-2.032 0-1.406-1.113-1.904-2.998-2.734l-1.025-.44c-2.969-1.26-4.932-2.851-4.932-6.2 0-3.087 2.354-5.43 6.016-5.43 2.617 0 4.492.908 5.84 3.29l-3.203 2.051c-.704-1.26-1.465-1.758-2.647-1.758-1.201 0-1.963.762-1.963 1.758 0 1.23.762 1.729 2.53 2.5l1.025.44c3.496 1.494 5.459 3.027 5.459 6.465 0 3.691-2.91 5.722-6.807 5.722Z"
      />
    </svg>
  );
};

export default Javascript;
